module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-driver driver"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 5
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('driver-action-buttons', {
    attrs: {
      "driver": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "small-6",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('thumbnail', {
    attrs: {
      "image": _vm.item.profile_picture
    }
  })], 1), _c('driver-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'driver-info'
    },
    slot: "n2"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'city'
    },
    slot: "n3"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'created'
    },
    slot: "n4"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'phone-and-email'
    },
    slot: "n5"
  }), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'driver',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1)]) : _vm._e(), (_vm.$is('pendingDelete')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 5
    }
  }, [_c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('driver-action-buttons', {
    attrs: {
      "driver": _vm.item,
      "pending-delete": true
    }
  })], 1)], 1), _c('div', {
    staticClass: "small-6",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('thumbnail', {
    attrs: {
      "image": _vm.item.profile_picture
    }
  })], 1), _c('driver-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'driver-info'
    },
    slot: "n2"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'city'
    },
    slot: "n3"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'created'
    },
    slot: "n4"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'phone-and-email'
    },
    slot: "n5"
  }), _c('div', {
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'driver',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)], 1)], 1)]) : _vm._e(), (_vm.$is('approvalListing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('driver-action-buttons', {
    attrs: {
      "driver": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-1 align-self-middle thumb-container"
  }, [_c('thumbnail', {
    attrs: {
      "image": _vm.item.profile_picture
    }
  })], 1), _c('div', {
    staticClass: "columns n2 align-self-middle"
  }, [_c('driver-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'driver-info-no-status'
    },
    slot: "n2"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'phone-and-email'
    },
    slot: "n5"
  })], 1), _c('div', {
    staticClass: "columns small-6 align-self-middle text-center"
  }, [_c('AccountStatus', {
    attrs: {
      "statuses": ['client', 'address', 'subscription', 'document_status'],
      "accountStatus": _vm.accountStatus
    }
  })], 1), _c('div', {
    staticClass: "columns shrink n4 align-self-middle"
  }, [_c('driver-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'created'
    },
    slot: "n5"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'updated'
    },
    slot: "n5"
  })], 1)])]), _c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'driver',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])])])]) : _vm._e(), (_vm.$is('onlyname')) ? _c('div', {
    staticClass: "onlyname"
  }, [_c('driver-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'driver-fullname'
    }
  })], 1) : _vm._e(), (_vm.$is('oneLook')) ? _c('div', {
    staticClass: "onelook"
  }, [_c('driver-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'driver-info'
    },
    slot: "n1"
  })], 1) : _vm._e(), (_vm.$is('driver-card')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "driver-card inner-content"
  }, [_c('div', {
    staticClass: "row collapse align-middle"
  }, [_c('div', {
    staticClass: "columns shrink"
  }, [_c('thumbnail', {
    attrs: {
      "image": _vm.item.profile_picture
    }
  })], 1), _c('div', {
    staticClass: "columns small-offset-1"
  }, [_c('div', {
    staticClass: "driver"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'driver',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname) + " (DR" + _vm._s(_vm.item.id) + ")")])])], 1), _c('div', {
    staticClass: "client"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.client_id
        }
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.client_organization_name) + " (CL" + _vm._s(_vm.item.client_id) + ")")])])], 1)])]), _c('div', {
    staticClass: "row"
  }, [(_vm.fakePicture) ? _c('div', {
    staticClass: "columns shrink"
  }, [_c('a', {
    staticClass: "m-1 fa fa-search-plus large fa-lg",
    on: {
      "click": function($event) {
        return _vm.openPicture(_vm.item.profile_picture_original)
      }
    }
  }), _c('a', {
    staticClass: "m-1 fa fa-trash large fa-lg",
    on: {
      "click": _vm.deletePicture
    }
  }), _c('ModalReveal', {
    ref: "reveal"
  }, [_c('img', {
    attrs: {
      "src": _vm.pictureOriginal,
      "width": "90%"
    }
  })])], 1) : _vm._e()]), _c('div', {
    staticClass: "row align-right align-middle"
  }, [(_vm.item.mobile) ? _c('a', {
    staticClass: "pr-2 fa fa-comments fa-lg",
    attrs: {
      "href": 'https://wa.me/' + _vm.item.mobile.replace('-', '').replace('+', ''),
      "target": "_blank"
    }
  }) : _vm._e(), (_vm.item.mobile) ? _c('a', {
    staticClass: "pr-2 fa fa-phone fa-lg",
    attrs: {
      "href": 'tel:' + _vm.item.mobile
    }
  }) : _vm._e(), (this.c2cEnabled && _vm.item.mobile) ? _c('CallButton', {
    attrs: {
      "phone": _vm.item.mobile
    }
  }) : _vm._e(), (_vm.item.email) ? _c('a', {
    staticClass: "pr-2 fa fa-envelope fa-lg",
    attrs: {
      "href": 'mailto:' + _vm.item.email
    }
  }) : _vm._e(), _c('DriverNotes', {
    attrs: {
      "driver_id": _vm.item.id,
      "type": 'noteCard'
    }
  })], 1)])]) : _vm._e(), (_vm.$is('driver-card-approval')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "driver-card inner-content"
  }, [_c('CardN', {
    attrs: {
      "columns": 12
    }
  }, [_c('thumbnail', {
    attrs: {
      "slot": "n1",
      "image": _vm.item.profile_picture
    },
    slot: "n1"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'driver-info'
    },
    slot: "n2"
  })], 1)], 1)]) : _vm._e(), (_vm.$is('driver-data')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('simple-columns33', [_c('div', {
    staticClass: "field field-first-name",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("First Name")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "field-last-name",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Last name")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.surname))])]), _c('div', {
    staticClass: "field-birthday",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Date Of Birth")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.birthdate, 'DD MMMM YYYY')))])]), _c('div', {
    staticClass: "field-gender",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Gender")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.gender))])]), _c('div', {
    staticClass: "field-country",
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Country")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.address.country))])]), _c('div', {
    staticClass: "field-address",
    attrs: {
      "slot": "n6"
    },
    slot: "n6"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Address")]), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.item.address.street) + " " + _vm._s(_vm.item.address.city) + " " + _vm._s(_vm.item.address.country))]), _c('div', {
    staticClass: "postal-code"
  }, [_vm._v(_vm._s(_vm.item.address.postal_code))])])]), _c('simple-columns33', [_c('div', {
    staticClass: "field-username",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Username")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.username))])]), _c('div', {
    staticClass: "field-member-id",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Member Id")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.id) + " - " + _vm._s(_vm.item.uid))])]), _c('div', {
    staticClass: "field-created",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Member Since")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, 'DD MMMM YYYY')))])]), _c('div', {
    staticClass: "field-status",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))])])]), _c('simple-columns33', [_c('div', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Created")]), _c('driver-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'created'
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Updated")]), _c('driver-fields', {
    attrs: {
      "item": _vm.item,
      "fieldName": 'updated'
    }
  })], 1)]), _c('simple-columns33', [_c('div', {
    staticClass: "field-email",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Email")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.email))])]), _c('div', {
    staticClass: "field-phone",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Phone")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.phone))])]), _c('div', {
    staticClass: "field-mobile",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Mobile")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.mobile))])])]), (_vm.item.extra && _vm.item.extra['app-version']) ? [_c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("App version")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.extra['app-version']))])])]), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.item.extra.device), function(extra, key, index) {
    return _c('div', {
      staticClass: "column large-4 small-6",
      attrs: {
        "slot": "n" + index
      },
      slot: "n" + index
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(key))]), _c('div', {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(extra))])])
  }), 0)] : _vm._e()], 2) : _vm._e(), (_vm.$is('client-drivers')) ? _c('div', {
    staticClass: "client-drivers"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card10', {
    attrs: {
      "showBullets": true
    }
  }, [_c('driver-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'driver-id'
    },
    slot: "n1"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item,
      "fieldName": 'driver-uid'
    },
    slot: "n1"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item,
      "fieldName": 'driver-name'
    },
    slot: "n2"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n3",
      "item": _vm.item,
      "fieldName": 'driver-surname'
    },
    slot: "n3"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n4",
      "item": _vm.item,
      "fieldName": 'driver-gender'
    },
    slot: "n4"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n5",
      "item": _vm.item,
      "fieldName": 'driver-country'
    },
    slot: "n5"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n6",
      "item": _vm.item,
      "fieldName": 'city'
    },
    slot: "n6"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n7",
      "item": _vm.item,
      "fieldName": 'driver-status'
    },
    slot: "n7"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n8",
      "item": _vm.item,
      "fieldName": 'created'
    },
    slot: "n8"
  }), _c('driver-fields', {
    attrs: {
      "slot": "n9",
      "item": _vm.item,
      "fieldName": 'updated'
    },
    slot: "n9"
  }), _c('div', {
    attrs: {
      "slot": "actionBullets"
    },
    slot: "actionBullets"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'top'
    }
  }, [_c('driver-action-buttons', {
    attrs: {
      "driver": _vm.item
    }
  })], 1)], 1)], 1)], 1)])]) : _vm._e(), (_vm.$is('groupList')) ? _c('div', {
    staticClass: "group-drivers"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Driver")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("D" + _vm._s(_vm.item.id) + " " + _vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])]) : _vm._e(), ((_vm.item.status === 'SUSPENDED' || _vm.item.status === 'ON HOLD') && _vm.type === 'highlightedNotes') ? _c('div', {
    staticClass: "card"
  }, [_c('DriverNotes', {
    attrs: {
      "driver_id": _vm.item.id,
      "type": 'highlightedNotes'
    },
    on: {
      "notes": _vm.retriveLastNotes
    }
  }), _c('div', {
    staticClass: "row column pl-2 pr-2 pt-2 pb-2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("last two notes " + _vm._s(_vm.type))]), _vm._l((_vm.lastNotes), function(lastNote, key) {
    return _c('div', {
      staticClass: "row column small-12"
    }, [_vm._v(_vm._s(lastNote))])
  })], 2)], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09bff5df!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Driver.vue
// module id = 2122
// module chunks = 1